export const API_KEY_ATTRIBUTE = 'api-key';
export const ENTRY_ATTRIBUTE = 'entry';
export const MODEL_ATTRIBUTE = 'model';

export const OBSERVE_DEBOUNCE_TIME = 500;
export const ERROR_DEBOUNCE_TIME = 1500;
export const BUILDER_ERROR_CASS = '.builder-loaded.builder-no-content-found';
export const BUILDER_LOADING_CLASS = '.builder-loading';
export const BUILDER_CONTENT_LOADED = '.builder-loaded';
